export default {
  en: {
    count_label: {
      one: 'Vote',
      other: 'Votes',
    },
    snack: {
      check_success: 'Voted successfully!',
      uncheck_success: 'Vote removed successfully!',
    },
    loading: 'Loading...',
    add_vote: 'Vote',
    remove_vote: 'Remove vote',
  },
};
